<template>
  <div>
    <!-- Nome -->
    <div class="wg-row">
      <div
        class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline"
      >{{ $anm22.strLang(lang, 'Name', 'Nome') }}</div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <input
          disabled
          class="anm22-calendar-input-text"
          style="max-width:100%;"
          type="text"
          v-model="event.name"
          :placeholder="$anm22.strLang(lang, 'Name event', 'Nome evento')"
        />
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <!-- Scelta calendario aziendale -->
    <!-- <div class="wg-row">
      <div
        class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline"
      >{{$anm22.strLang(lang, 'Calendar', 'Calendario')}}</div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <select disabled required class="com-anm22-app-select" style="max-width:100%;" v-model="event.work">
          <option value="0">{{ $anm22.strLang(lang, 'Private', 'Privato') }}</option>
          <option
            v-for="(obj,index) in works"
            :key="'work-'+index"
            :value="obj.idWorldWork"
          >{{ obj.name }}</option>
        </select>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div> -->
    <!-- Indirizzo di consegna (campo note dell'evento) -->
    <div class="wg-row">
      <div
        class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline"
      >{{ $anm22.strLang(lang, 'Delivery', 'Consegna') }}</div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <textarea disabled style="margin:0;max-width:100%;" v-model="event.notes" rows="3"></textarea>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <!-- Data / Ora -->
    <div class="wg-row">
      <div
        class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline"
      >{{ $anm22.strLang(lang, 'Date', 'Data') }}</div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <input disabled type="date" v-model="eventDate" />
      </div>
    </div>
    <!-- <div class="vertical-height-div" style="height:10px;"></div> -->
    <!-- Timezone -->
    <!-- <div class="wg-row">
      <div
        class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline"
      >{{ $anm22.strLang(lang, 'Timezone', 'Fuso orario') }}</div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <select disabled class="com-anm22-app-select" style="max-width:100%;" v-model="event.timezone">
          <option :value="null" disabled hidden>{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
          <option
            v-for="(obj,key,index) in $anm22.tableClasses.worldTimezone().getAll()"
            :key="'timezone-'+index"
            :value="key"
          >{{ obj[lang] }}</option>
        </select>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    eventRef: Object
  },
  data() {
    return {
      event: {...this.eventRef}
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang
    }),
    works() {
      return this.$store.getters["works/getAll"];
    },
    eventDate() {
      return this.$moment
        .unix(this.event.startTimestamp)
        .format("YYYY-MM-DD");
    },
  }
}
</script>

<style lang="scss" scoped>

</style>